export const AUTH_MESSAGES = {
  unavailable: 'ログイン機能はまだ設定されていません。環境変数を確認してください。',
  sessionLoadFailed: 'ログイン状態の確認に失敗しました。時間をおいて再度お試しください。',
  signInFailed: 'ログインに失敗しました。メールアドレスとパスワードを確認してください。',
  signUpFailed: 'アカウント作成に失敗しました。入力内容を確認してください。',
  signOutFailed: 'ログアウトに失敗しました。時間をおいて再度お試しください。',
  signUpSuccess: '確認メールを送信しました。メール内のリンクから登録を完了してください。',
  invalidForm: 'メールアドレスとパスワードを入力してください。',
  passwordTooShort: 'パスワードは8文字以上で入力してください。',
} as const;

export function mapAuthErrorMessage(error: unknown, fallback: string): string {
  if (!error || typeof error !== 'object') return fallback;

  const maybeMessage = 'message' in error && typeof error.message === 'string'
    ? error.message.toLowerCase()
    : '';

  if (maybeMessage.includes('invalid login credentials')) return AUTH_MESSAGES.signInFailed;
  if (maybeMessage.includes('email rate limit exceeded')) return 'しばらく待ってから再度お試しください。';
  if (maybeMessage.includes('user already registered')) return 'このメールアドレスはすでに登録されています。';
  if (maybeMessage.includes('password should be at least')) return AUTH_MESSAGES.passwordTooShort;
  if (maybeMessage.includes('invalid email')) return 'メールアドレスの形式を確認してください。';

  return fallback;
}

